export default class PrintHelper {
  static printElement(element) {
    const printWindow = window.open('', '_blank');
    const styles = Array.from(document.styleSheets)
      .map(styleSheet => {
        try {
          return Array.from(styleSheet.cssRules).map(rule => rule.cssText).join('');
        } catch (e) { return ''; }
      }).join('');

    printWindow.document.write(`
      <html>
        <head><style>${styles}</style></head>
        <body>${element.innerHTML}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  }
}